module.exports = __webpack_public_path__ + "static/media/AnovaUI-Light.9ce96c09.woff2";